<script>
import Cookies from "js-cookie";

const COOKIE_KEY = "OptanonAlertBoxClosed";

export default {
  name: "cookie-banner",

  data() {
    return {
      hidden: true,
      open: false,
      previousFocus: null,
    };
  },

  mounted() {
    const hasAgreed = Cookies.get(COOKIE_KEY);
    if (!hasAgreed) this.show();
  },

  methods: {
    hide() {
      Cookies.set(COOKIE_KEY, new Date());
      this.open = false;

      // Return focus to previously focused element
      if (this.previousFocus && this.previousFocus.focus) {
        this.previousFocus.focus();
        this.previousFocus = null;
      }

      setTimeout(() => {
        this.hidden = true;
      }, 500);
    },

    show() {
      this.hidden = false;
      this.open = true;

      // Save current focus and move to close button after slide-in
      this.previousFocus = document.activeElement;
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.closeBtn) this.$refs.closeBtn.focus();
        }, 600); // After the 0.5s transition-delay + transition
      });
    },

    close(e) {
      this.hide();
    },
  },
};
</script>
